import client from "./client";

export function getMonthlySummaries() {
  return client.get("/api/monthly_summaries/").then((res) => res.data);
}

export function getCurrentSummary() {
  return client.get("/api/current_summary/").then((res) => res.data);
}
